var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'tsyringe';
import firebase from 'firebase/app';
let AuthDataSource = class AuthDataSource {
    isLoggedIn() {
        const user = firebase.auth().currentUser;
        return user !== null ? true : false;
    }
    loggedInUserId() {
        var _a;
        const user = firebase.auth().currentUser;
        return (_a = user) === null || _a === void 0 ? void 0 : _a.uid;
    }
    async loginWithEmail(email, password, persistence) {
        // https://firebase.google.com/docs/auth/web/auth-state-persistence?hl=ja#supported_types_of_auth_state_persistence
        await firebase.auth().setPersistence(firebase.auth.Auth.Persistence[persistence]);
        return await firebase.auth().signInWithEmailAndPassword(email, password);
    }
    async updatePassword(oldPassword, newPassword) {
        const user = firebase.auth().currentUser;
        if (user === null)
            throw new Error('user is null');
        const email = user.email;
        const credential = firebase.auth.EmailAuthProvider.credential(email, oldPassword);
        await user.reauthenticateWithCredential(credential);
        await user.updatePassword(newPassword);
    }
    async updateEmail(password, newEmail) {
        const user = firebase.auth().currentUser;
        if (user === null)
            throw new Error('user is null');
        const email = user.email;
        const credential = firebase.auth.EmailAuthProvider.credential(email, password);
        await user.reauthenticateWithCredential(credential);
        await user.updateEmail(newEmail);
    }
    async sendEmailVerification() {
        var _a, _b;
        const user = firebase.auth().currentUser;
        await ((_a = user) === null || _a === void 0 ? void 0 : _a.sendEmailVerification());
        return (_b = user) === null || _b === void 0 ? void 0 : _b.uid;
    }
    async sendPasswordResetEmail(email) {
        await firebase.auth().sendPasswordResetEmail(email);
    }
    async logout() {
        return await firebase.auth().signOut();
    }
    onAuthListener(onChange, onError) {
        return firebase.auth().onAuthStateChanged(onChange, onError);
    }
};
AuthDataSource = __decorate([
    injectable()
], AuthDataSource);
export { AuthDataSource };
